import {useTheme} from '@mui/material';

import {REPORT_PARAMETERS_ACCORDIONS_IDS} from '../../../../const';
import useReportParameters from '../../../../hooks/providers/useReportParameters';
import CategoryAccordion from '../../shared/CategoryAccordion/CategoryAccordion';
import CategoryAccordionIcon from '../../shared/CategoryAccordionIcon/CategoryAccordionIcon';
import ParametersList from '../ParametersList/ParametersList';

const Parameters = () => {
  const theme = useTheme();
  const {currentReport, reportParametersCategoryExpanded} = useReportParameters();

  const numberOfParameters = currentReport?.parameters?.length ?? 0;
  const plural = numberOfParameters > 1 ? 's' : '';
  const subtitle = `${numberOfParameters} paramètre${plural} configuré${plural}`;
  const isExpanded = reportParametersCategoryExpanded === REPORT_PARAMETERS_ACCORDIONS_IDS.PARAMETERS;

  console.log({numberOfParameters});
  return (
    <CategoryAccordion
      disabled={numberOfParameters === 0}
      id={REPORT_PARAMETERS_ACCORDIONS_IDS.PARAMETERS}
      icon={<CategoryAccordionIcon iconName="Tune" color={theme.palette.primary.main} />}
      title="Paramètres"
      subtitle={subtitle}
      expanded={isExpanded}
      renderActionsSection={() => null}
    >
      {numberOfParameters === 0 ? null : <ParametersList />}
    </CategoryAccordion>
  );
};

export default Parameters;
